import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex justify-center flex-wrap",
  style: {"gap":"5px"}
}
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { class: "justify-start flex-wrap mb-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "Detalhes da Licença", -1)
const _hoisted_5 = { class: "d-flex justify-space-between" }
const _hoisted_6 = { class: "title-prop" }
const _hoisted_7 = { class: "title-prop" }
const _hoisted_8 = { class: "title-prop" }
const _hoisted_9 = { class: "justify-center text-center flex-wrap mt-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-2" }, "Qtd. de Licenças", -1)

import { ref, watch, withDefaults, onMounted } from 'vue';
import { MoleculeModal, MoleculeListActions } from '@/components/molecules';
import { Application, ApplicationVersion, Company, Group, Licence, LicenceGroup, User } from '@/core/model';
import { create, update } from '@/core/service/UserService';

import { getAll as groupAll } from '@/core/service/GroupService';
import { validateCPF, validateEmail } from '@/core/service/ValidateService';
import { Preloader } from '@/store';
import Swal from 'sweetalert2';
import {
  AtomInput,
  GroupIcon,
  AtomButton,
  SearchIcon,
  AtomCheckBox,
  AtomAccordion,
  AtomSelect,
} from '@/components/atoms';
import { computed } from 'vue';
import { Authentication } from '@/store';
import { increment } from '@/core/service/LicenceService';

interface IProps {
  showModal: boolean;
  licence?: Licence;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeAddLicenseModal',
  props: {
    showModal: { type: Boolean, default: false },
    licence: null
  },
  emits: ['onHandleClose'],
  setup(__props: any, { emit }) {

const props = __props as { showModal: boolean, licence?: Licence };



const uses_increment = ref<number>(0);

const disabledButton = computed(() => {
  return !uses_increment.value;
});

function handleIncremente() {
  increment({ id: props.licence?.id, uses_increment: uses_increment.value }).then(() => {
    Swal.fire({
      icon: 'success',
      title: 'Sucesso',
      text: 'Adição de licença realizado com sucesso',
    }).then(() => {
      emit('onHandleClose', false);
    });
  });
}

function clear() {
  uses_increment.value = 0;
  emit('onHandleClose', false);
}

return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createBlock(_unref(MoleculeModal), {
    width: "649px",
    onHandleConfirm: handleIncremente,
    onHandleCancel: clear,
    icon: "ArchiveBookIcon",
    iconColor: "#5528B5",
    title: "Adicionar mais licenças",
    show: __props.showModal,
    "btn-close-text": "Cancelar",
    "btn-confirm-text": "Adicionar",
    btnConfitmDisabled: _unref(disabledButton)
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, "Aplicação: " + _toDisplayString(__props.licence?.application_name ?? 'Aplicação'), 1),
              _createElementVNode("p", _hoisted_7, "Versão: " + _toDisplayString(__props.licence?.application_version.version ?? 'Versão'), 1),
              _createElementVNode("p", _hoisted_8, "Fabricantes: " + _toDisplayString(__props.licence?.permitted_manufacturers?.join(', ') ?? ' Permitidos'), 1)
            ])
          ]),
          _createVNode(_component_v_divider, { class: "mt-2" }),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_unref(AtomInput), {
              modelValue: uses_increment.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((uses_increment).value = $event)),
              "prepend-icon": "",
              "append-icon": "",
              "max-width": '142px',
              type: "number",
              min: "0",
              height: "32px",
              alignInput: "center",
              classes: "d-flex justify-center"
            }, {
              appendIcon: _withCtx(() => [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (uses_increment.value += 1), ["prevent"]))
                }, "+")
              ]),
              prependIcon: _withCtx(() => [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ((uses_increment.value ?? 0) > 0 ? (uses_increment.value -= 1) : uses_increment.value), ["prevent"]))
                }, " - ")
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["show", "btnConfitmDisabled"]))
}
}

})